
import React from 'react'
import { Animated } from 'react-web-animation'

export default class RoomL extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      originalWidth: 1051,
      originalHeight: 944
    }
    this.state = {
      ...this.state,
      width: parseFloat(props.width),
      height: this.state.originalHeight / (this.state.originalWidth / parseFloat(props.width)),
      ratio: this.state.originalWidth / parseFloat(props.width)
    }
  }
  render() {
    return (
      <div>
        <svg height={this.state.height} width={this.state.width} viewBox={`0 0 ${this.state.originalWidth} ${this.state.originalHeight}`}>
          <defs>
            <polygon id="path-1" points="26.6699404 26.6699404 90.5330086 15.5330086 79.3960768 79.3960768 15.5330086 90.5330086"/>
            <polygon id="path-2" points="236.66994 173.66994 300.533009 162.533009 289.396077 226.396077 225.533009 237.533009"/>
            <polygon id="path-3" points="131.66994 100.16994 195.533009 89.0330086 184.396077 152.896077 120.533009 164.033009"/>
            <polygon id="path-4" points="341.66994 247.16994 405.533009 236.033009 394.396077 299.896077 330.533009 311.033009"/>
            <polygon id="path-5" points="446.66994 320.827949 510.533009 309.691017 499.396077 373.554085 435.533009 384.691017"/>
            <polygon id="path-6" points="79.1699404 63.4199404 143.033009 52.2830086 131.896077 116.146077 68.0330086 127.283009"/>
            <polygon id="path-7" points="289.16994 210.41994 353.033009 199.283009 341.896077 263.146077 278.033009 274.283009"/>
            <polygon id="path-8" points="184.16994 136.91994 248.033009 125.783009 236.896077 189.646077 173.033009 200.783009"/>
            <polygon id="path-9" points="394.16994 283.91994 458.033009 272.783009 446.896077 336.646077 383.033009 347.783009"/>
            <polygon id="path-10" points="499.16994 357.577949 563.033009 346.441017 551.896077 410.304085 488.033009 421.441017"/>
            <polygon id="path-11" points="26.6699404 26.6699404 90.5330086 15.5330086 79.3960768 79.3960768 15.5330086 90.5330086"/>
            <polygon id="path-12" points="236.66994 173.66994 300.533009 162.533009 289.396077 226.396077 225.533009 237.533009"/>
            <polygon id="path-13" points="131.66994 100.16994 195.533009 89.0330086 184.396077 152.896077 120.533009 164.033009"/>
            <polygon id="path-14" points="341.66994 247.16994 405.533009 236.033009 394.396077 299.896077 330.533009 311.033009"/>
            <polygon id="path-15" points="446.66994 320.827949 510.533009 309.691017 499.396077 373.554085 435.533009 384.691017"/>
            <polygon id="path-16" points="79.1699404 63.4199404 143.033009 52.2830086 131.896077 116.146077 68.0330086 127.283009"/>
            <polygon id="path-17" points="289.16994 210.41994 353.033009 199.283009 341.896077 263.146077 278.033009 274.283009"/>
            <polygon id="path-18" points="184.16994 136.91994 248.033009 125.783009 236.896077 189.646077 173.033009 200.783009"/>
            <polygon id="path-19" points="394.16994 283.91994 458.033009 272.783009 446.896077 336.646077 383.033009 347.783009"/>
            <polygon id="path-20" points="499.16994 357.577949 563.033009 346.441017 551.896077 410.304085 488.033009 421.441017"/>
            <polygon id="path-21" points="26.6699404 26.6699404 90.5330086 15.5330086 79.3960768 79.3960768 15.5330086 90.5330086"/>
            <polygon id="path-22" points="236.66994 173.66994 300.533009 162.533009 289.396077 226.396077 225.533009 237.533009"/>
            <polygon id="path-23" points="131.66994 100.16994 195.533009 89.0330086 184.396077 152.896077 120.533009 164.033009"/>
            <polygon id="path-24" points="341.66994 247.16994 405.533009 236.033009 394.396077 299.896077 330.533009 311.033009"/>
            <polygon id="path-25" points="446.66994 320.827949 510.533009 309.691017 499.396077 373.554085 435.533009 384.691017"/>
            <polygon id="path-26" points="79.1699404 63.4199404 143.033009 52.2830086 131.896077 116.146077 68.0330086 127.283009"/>
            <polygon id="path-27" points="289.16994 210.41994 353.033009 199.283009 341.896077 263.146077 278.033009 274.283009"/>
            <polygon id="path-28" points="184.16994 136.91994 248.033009 125.783009 236.896077 189.646077 173.033009 200.783009"/>
            <polygon id="path-29" points="394.16994 283.91994 458.033009 272.783009 446.896077 336.646077 383.033009 347.783009"/>
            <polygon id="path-30" points="499.16994 357.577949 563.033009 346.441017 551.896077 410.304085 488.033009 421.441017"/>
            <polygon id="path-31" points="26.6699404 26.6699404 90.5330086 15.5330086 79.3960768 79.3960768 15.5330086 90.5330086"/>
            <polygon id="path-32" points="236.66994 173.66994 300.533009 162.533009 289.396077 226.396077 225.533009 237.533009"/>
            <polygon id="path-33" points="131.66994 100.16994 195.533009 89.0330086 184.396077 152.896077 120.533009 164.033009"/>
            <polygon id="path-34" points="341.66994 247.16994 405.533009 236.033009 394.396077 299.896077 330.533009 311.033009"/>
            <polygon id="path-35" points="446.66994 320.827949 510.533009 309.691017 499.396077 373.554085 435.533009 384.691017"/>
            <polygon id="path-36" points="79.1699404 63.4199404 143.033009 52.2830086 131.896077 116.146077 68.0330086 127.283009"/>
            <polygon id="path-37" points="289.16994 210.41994 353.033009 199.283009 341.896077 263.146077 278.033009 274.283009"/>
            <polygon id="path-38" points="184.16994 136.91994 248.033009 125.783009 236.896077 189.646077 173.033009 200.783009"/>
            <polygon id="path-39" points="394.16994 283.91994 458.033009 272.783009 446.896077 336.646077 383.033009 347.783009"/>
            <polygon id="path-40" points="499.16994 357.577949 563.033009 346.441017 551.896077 410.304085 488.033009 421.441017"/>
            <polygon id="path-41" points="26.6699404 26.6699404 90.5330086 15.5330086 79.3960768 79.3960768 15.5330086 90.5330086"/>
            <polygon id="path-42" points="236.66994 173.66994 300.533009 162.533009 289.396077 226.396077 225.533009 237.533009"/>
            <polygon id="path-43" points="131.66994 100.16994 195.533009 89.0330086 184.396077 152.896077 120.533009 164.033009"/>
            <polygon id="path-44" points="341.66994 247.16994 405.533009 236.033009 394.396077 299.896077 330.533009 311.033009"/>
            <polygon id="path-45" points="446.66994 320.827949 510.533009 309.691017 499.396077 373.554085 435.533009 384.691017"/>
            <polygon id="path-46" points="79.1699404 63.4199404 143.033009 52.2830086 131.896077 116.146077 68.0330086 127.283009"/>
            <polygon id="path-47" points="289.16994 210.41994 353.033009 199.283009 341.896077 263.146077 278.033009 274.283009"/>
            <polygon id="path-48" points="184.16994 136.91994 248.033009 125.783009 236.896077 189.646077 173.033009 200.783009"/>
            <polygon id="path-49" points="394.16994 283.91994 458.033009 272.783009 446.896077 336.646077 383.033009 347.783009"/>
            <polygon id="path-50" points="499.16994 357.577949 563.033009 346.441017 551.896077 410.304085 488.033009 421.441017"/>
            <polygon id="path-51" points="26.6699404 26.6699404 90.5330086 15.5330086 79.3960768 79.3960768 15.5330086 90.5330086"/>
            <polygon id="path-52" points="236.66994 173.66994 300.533009 162.533009 289.396077 226.396077 225.533009 237.533009"/>
            <polygon id="path-53" points="131.66994 100.16994 195.533009 89.0330086 184.396077 152.896077 120.533009 164.033009"/>
            <polygon id="path-54" points="341.66994 247.16994 405.533009 236.033009 394.396077 299.896077 330.533009 311.033009"/>
            <polygon id="path-55" points="446.66994 320.827949 510.533009 309.691017 499.396077 373.554085 435.533009 384.691017"/>
            <polygon id="path-56" points="79.1699404 63.4199404 143.033009 52.2830086 131.896077 116.146077 68.0330086 127.283009"/>
            <polygon id="path-57" points="289.16994 210.41994 353.033009 199.283009 341.896077 263.146077 278.033009 274.283009"/>
            <polygon id="path-58" points="184.16994 136.91994 248.033009 125.783009 236.896077 189.646077 173.033009 200.783009"/>
            <polygon id="path-59" points="394.16994 283.91994 458.033009 272.783009 446.896077 336.646077 383.033009 347.783009"/>
            <polygon id="path-60" points="499.16994 357.577949 563.033009 346.441017 551.896077 410.304085 488.033009 421.441017"/>
            <polygon id="path-61" points="26.6699404 26.6699404 90.5330086 15.5330086 79.3960768 79.3960768 15.5330086 90.5330086"/>
            <polygon id="path-62" points="236.66994 173.66994 300.533009 162.533009 289.396077 226.396077 225.533009 237.533009"/>
            <polygon id="path-63" points="131.66994 100.16994 195.533009 89.0330086 184.396077 152.896077 120.533009 164.033009"/>
            <polygon id="path-64" points="341.66994 247.16994 405.533009 236.033009 394.396077 299.896077 330.533009 311.033009"/>
            <polygon id="path-65" points="446.66994 320.827949 510.533009 309.691017 499.396077 373.554085 435.533009 384.691017"/>
            <polygon id="path-66" points="79.1699404 63.4199404 143.033009 52.2830086 131.896077 116.146077 68.0330086 127.283009"/>
            <polygon id="path-67" points="289.16994 210.41994 353.033009 199.283009 341.896077 263.146077 278.033009 274.283009"/>
            <polygon id="path-68" points="184.16994 136.91994 248.033009 125.783009 236.896077 189.646077 173.033009 200.783009"/>
            <polygon id="path-69" points="394.16994 283.91994 458.033009 272.783009 446.896077 336.646077 383.033009 347.783009"/>
            <polygon id="path-70" points="499.16994 357.577949 563.033009 346.441017 551.896077 410.304085 488.033009 421.441017"/>
            <polygon id="path-71" points="26.6699404 26.6699404 90.5330086 15.5330086 79.3960768 79.3960768 15.5330086 90.5330086"/>
            <polygon id="path-72" points="236.66994 173.66994 300.533009 162.533009 289.396077 226.396077 225.533009 237.533009"/>
            <polygon id="path-73" points="131.66994 100.16994 195.533009 89.0330086 184.396077 152.896077 120.533009 164.033009"/>
            <polygon id="path-74" points="341.66994 247.16994 405.533009 236.033009 394.396077 299.896077 330.533009 311.033009"/>
            <polygon id="path-75" points="446.66994 320.827949 510.533009 309.691017 499.396077 373.554085 435.533009 384.691017"/>
            <polygon id="path-76" points="79.1699404 63.4199404 143.033009 52.2830086 131.896077 116.146077 68.0330086 127.283009"/>
            <polygon id="path-77" points="289.16994 210.41994 353.033009 199.283009 341.896077 263.146077 278.033009 274.283009"/>
            <polygon id="path-78" points="184.16994 136.91994 248.033009 125.783009 236.896077 189.646077 173.033009 200.783009"/>
            <polygon id="path-79" points="394.16994 283.91994 458.033009 272.783009 446.896077 336.646077 383.033009 347.783009"/>
            <polygon id="path-80" points="499.16994 357.577949 563.033009 346.441017 551.896077 410.304085 488.033009 421.441017"/>
            <polygon id="path-81" points="26.6699404 26.6699404 90.5330086 15.5330086 79.3960768 79.3960768 15.5330086 90.5330086"/>
            <polygon id="path-82" points="236.66994 173.66994 300.533009 162.533009 289.396077 226.396077 225.533009 237.533009"/>
            <polygon id="path-83" points="131.66994 100.16994 195.533009 89.0330086 184.396077 152.896077 120.533009 164.033009"/>
            <polygon id="path-84" points="341.66994 247.16994 405.533009 236.033009 394.396077 299.896077 330.533009 311.033009"/>
            <polygon id="path-85" points="446.66994 320.827949 510.533009 309.691017 499.396077 373.554085 435.533009 384.691017"/>
            <polygon id="path-86" points="79.1699404 63.4199404 143.033009 52.2830086 131.896077 116.146077 68.0330086 127.283009"/>
            <polygon id="path-87" points="289.16994 210.41994 353.033009 199.283009 341.896077 263.146077 278.033009 274.283009"/>
            <polygon id="path-88" points="184.16994 136.91994 248.033009 125.783009 236.896077 189.646077 173.033009 200.783009"/>
            <polygon id="path-89" points="394.16994 283.91994 458.033009 272.783009 446.896077 336.646077 383.033009 347.783009"/>
            <polygon id="path-90" points="499.16994 357.577949 563.033009 346.441017 551.896077 410.304085 488.033009 421.441017"/>
            <polygon id="path-91" points="26.6699404 26.6699404 90.5330086 15.5330086 79.3960768 79.3960768 15.5330086 90.5330086"/>
            <polygon id="path-92" points="236.66994 173.66994 300.533009 162.533009 289.396077 226.396077 225.533009 237.533009"/>
            <polygon id="path-93" points="131.66994 100.16994 195.533009 89.0330086 184.396077 152.896077 120.533009 164.033009"/>
            <polygon id="path-94" points="341.66994 247.16994 405.533009 236.033009 394.396077 299.896077 330.533009 311.033009"/>
            <polygon id="path-95" points="446.66994 320.827949 510.533009 309.691017 499.396077 373.554085 435.533009 384.691017"/>
            <polygon id="path-96" points="79.1699404 63.4199404 143.033009 52.2830086 131.896077 116.146077 68.0330086 127.283009"/>
            <polygon id="path-97" points="289.16994 210.41994 353.033009 199.283009 341.896077 263.146077 278.033009 274.283009"/>
            <polygon id="path-98" points="184.16994 136.91994 248.033009 125.783009 236.896077 189.646077 173.033009 200.783009"/>
            <polygon id="path-99" points="394.16994 283.91994 458.033009 272.783009 446.896077 336.646077 383.033009 347.783009"/>
            <polygon id="path-100" points="499.16994 357.577949 563.033009 346.441017 551.896077 410.304085 488.033009 421.441017"/>
          </defs>
          <g id="Packages/L" fill="none">
            <polygon id="Rectangle-8" fill="#DFDFDF" points="1.12727029 203 642 203 524.87273 370 -116 370" transform="rotate(-35 263 286.5)"/>
            <polygon id="Rectangle-8" fill="#929292" points="525.8493 204 1167 204 1049.91343 371 409 370.661584" transform="scale(-1 1) rotate(-35 0 2786.717)"/>
            <g id="Boden/10x10" transform="translate(0 189)">
              <g id="10m" transform="translate(0 330.75)">
                <g id="Rectangle-5" fill="#D8D8D8" transform="rotate(45 53.033 53.033)">
                  <path fill="#D8D8D8" d="M26.9940747,26.9940747 L15.9940717,90.0719455 L79.0719424,79.0719424 L90.0719455,15.9940717 L26.9940747,26.9940747 Z" stroke="#979797"/>
                </g>
                <g id="Rectangle-5" fill="#D8D8D8" transform="rotate(45 263.033 200.033)">
                  <path fill="#D8D8D8" d="M236.994075,173.994075 L225.994072,237.071946 L289.071942,226.071942 L300.071946,162.994072 L236.994075,173.994075 Z" stroke="#979797"/>
                </g>
                <g id="Rectangle-5" fill="#D8D8D8" transform="rotate(45 158.033 126.533)">
                  <path fill="#D8D8D8" d="M131.994075,100.494075 L120.994072,163.571946 L184.071942,152.571942 L195.071946,89.4940717 L131.994075,100.494075 Z" stroke="#979797"/>
                </g>
                <g id="Rectangle-5" fill="#D8D8D8" transform="rotate(45 368.033 273.533)">
                  <path fill="#D8D8D8" d="M341.994075,247.494075 L330.994072,310.571946 L394.071942,299.571942 L405.071946,236.494072 L341.994075,247.494075 Z" stroke="#979797"/>
                </g>
                <g id="Rectangle-5" fill="#D8D8D8" transform="rotate(45 473.033 347.191)">
                  <path fill="#D8D8D8" d="M446.994075,321.152083 L435.994072,384.229954 L499.071942,373.229951 L510.071946,310.15208 L446.994075,321.152083 Z" stroke="#979797"/>
                </g>
                <g id="Rectangle-5" fill="#D8D8D8" transform="rotate(45 105.533 89.783)">
                  <path fill="#D8D8D8" d="M79.4940747,63.7440747 L68.4940717,126.821946 L131.571942,115.821942 L142.571946,52.7440717 L79.4940747,63.7440747 Z" stroke="#979797"/>
                </g>
                <g id="Rectangle-5" fill="#D8D8D8" transform="rotate(45 315.533 236.783)">
                  <path fill="#D8D8D8" d="M289.494075,210.744075 L278.494072,273.821946 L341.571942,262.821942 L352.571946,199.744072 L289.494075,210.744075 Z" stroke="#979797"/>
                </g>
                <g id="Rectangle-5" fill="#D8D8D8" transform="rotate(45 210.533 163.283)">
                  <path fill="#D8D8D8" d="M184.494075,137.244075 L173.494072,200.321946 L236.571942,189.321942 L247.571946,126.244072 L184.494075,137.244075 Z" stroke="#979797"/>
                </g>
                <g id="Rectangle-5" fill="#D8D8D8" transform="rotate(45 420.533 310.283)">
                  <path fill="#D8D8D8" d="M394.494075,284.244075 L383.494072,347.321946 L446.571942,336.321942 L457.571946,273.244072 L394.494075,284.244075 Z" stroke="#979797"/>
                </g>
                <g id="Rectangle-5" fill="#D8D8D8" transform="rotate(45 525.533 383.941)">
                  <path fill="#D8D8D8" d="M499.494075,357.902083 L488.494072,420.979954 L551.571942,409.979951 L562.571946,346.90208 L499.494075,357.902083 Z" stroke="#979797"/>
                </g>
              </g>
              <g id="10m" transform="translate(52.5 294)">
                <g id="Rectangle-5" fill="#D8D8D8" transform="rotate(45 53.033 53.033)">
                  <path fill="#D8D8D8" d="M26.9940747,26.9940747 L15.9940717,90.0719455 L79.0719424,79.0719424 L90.0719455,15.9940717 L26.9940747,26.9940747 Z" stroke="#979797"/>
                </g>
                <g id="Rectangle-5" fill="#D8D8D8" transform="rotate(45 263.033 200.033)">
                  <path fill="#D8D8D8" d="M236.994075,173.994075 L225.994072,237.071946 L289.071942,226.071942 L300.071946,162.994072 L236.994075,173.994075 Z" stroke="#979797"/>
                </g>
                <g id="Rectangle-5" fill="#D8D8D8" transform="rotate(45 158.033 126.533)">
                  <path fill="#D8D8D8" d="M131.994075,100.494075 L120.994072,163.571946 L184.071942,152.571942 L195.071946,89.4940717 L131.994075,100.494075 Z" stroke="#979797"/>
                </g>
                <g id="Rectangle-5" fill="#D8D8D8" transform="rotate(45 368.033 273.533)">
                  <path fill="#D8D8D8" d="M341.994075,247.494075 L330.994072,310.571946 L394.071942,299.571942 L405.071946,236.494072 L341.994075,247.494075 Z" stroke="#979797"/>
                </g>
                <g id="Rectangle-5" fill="#D8D8D8" transform="rotate(45 473.033 347.191)">
                  <path fill="#D8D8D8" d="M446.994075,321.152083 L435.994072,384.229954 L499.071942,373.229951 L510.071946,310.15208 L446.994075,321.152083 Z" stroke="#979797"/>
                </g>
                <g id="Rectangle-5" fill="#D8D8D8" transform="rotate(45 105.533 89.783)">
                  <path fill="#D8D8D8" d="M79.4940747,63.7440747 L68.4940717,126.821946 L131.571942,115.821942 L142.571946,52.7440717 L79.4940747,63.7440747 Z" stroke="#979797"/>
                </g>
                <g id="Rectangle-5" fill="#D8D8D8" transform="rotate(45 315.533 236.783)">
                  <path fill="#D8D8D8" d="M289.494075,210.744075 L278.494072,273.821946 L341.571942,262.821942 L352.571946,199.744072 L289.494075,210.744075 Z" stroke="#979797"/>
                </g>
                <g id="Rectangle-5" fill="#D8D8D8" transform="rotate(45 210.533 163.283)">
                  <path fill="#D8D8D8" d="M184.494075,137.244075 L173.494072,200.321946 L236.571942,189.321942 L247.571946,126.244072 L184.494075,137.244075 Z" stroke="#979797"/>
                </g>
                <g id="Rectangle-5" fill="#D8D8D8" transform="rotate(45 420.533 310.283)">
                  <path fill="#D8D8D8" d="M394.494075,284.244075 L383.494072,347.321946 L446.571942,336.321942 L457.571946,273.244072 L394.494075,284.244075 Z" stroke="#979797"/>
                </g>
                <g id="Rectangle-5" fill="#D8D8D8" transform="rotate(45 525.533 383.941)">
                  <path fill="#D8D8D8" d="M499.494075,357.902083 L488.494072,420.979954 L551.571942,409.979951 L562.571946,346.90208 L499.494075,357.902083 Z" stroke="#979797"/>
                </g>
              </g>
              <g id="10m" transform="translate(105 257.25)">
                <g id="Rectangle-5" fill="#D8D8D8" transform="rotate(45 53.033 53.033)">
                  <path fill="#D8D8D8" d="M26.9940747,26.9940747 L15.9940717,90.0719455 L79.0719424,79.0719424 L90.0719455,15.9940717 L26.9940747,26.9940747 Z" stroke="#979797"/>
                </g>
                <g id="Rectangle-5" fill="#D8D8D8" transform="rotate(45 263.033 200.033)">
                  <path fill="#D8D8D8" d="M236.994075,173.994075 L225.994072,237.071946 L289.071942,226.071942 L300.071946,162.994072 L236.994075,173.994075 Z" stroke="#979797"/>
                </g>
                <g id="Rectangle-5" fill="#D8D8D8" transform="rotate(45 158.033 126.533)">
                  <path fill="#D8D8D8" d="M131.994075,100.494075 L120.994072,163.571946 L184.071942,152.571942 L195.071946,89.4940717 L131.994075,100.494075 Z" stroke="#979797"/>
                </g>
                <g id="Rectangle-5" fill="#D8D8D8" transform="rotate(45 368.033 273.533)">
                  <path fill="#D8D8D8" d="M341.994075,247.494075 L330.994072,310.571946 L394.071942,299.571942 L405.071946,236.494072 L341.994075,247.494075 Z" stroke="#979797"/>
                </g>
                <g id="Rectangle-5" fill="#D8D8D8" transform="rotate(45 473.033 347.191)">
                  <path fill="#D8D8D8" d="M446.994075,321.152083 L435.994072,384.229954 L499.071942,373.229951 L510.071946,310.15208 L446.994075,321.152083 Z" stroke="#979797"/>
                </g>
                <g id="Rectangle-5" fill="#D8D8D8" transform="rotate(45 105.533 89.783)">
                  <path fill="#D8D8D8" d="M79.4940747,63.7440747 L68.4940717,126.821946 L131.571942,115.821942 L142.571946,52.7440717 L79.4940747,63.7440747 Z" stroke="#979797"/>
                </g>
                <g id="Rectangle-5" fill="#D8D8D8" transform="rotate(45 315.533 236.783)">
                  <path fill="#D8D8D8" d="M289.494075,210.744075 L278.494072,273.821946 L341.571942,262.821942 L352.571946,199.744072 L289.494075,210.744075 Z" stroke="#979797"/>
                </g>
                <g id="Rectangle-5" fill="#D8D8D8" transform="rotate(45 210.533 163.283)">
                  <path fill="#D8D8D8" d="M184.494075,137.244075 L173.494072,200.321946 L236.571942,189.321942 L247.571946,126.244072 L184.494075,137.244075 Z" stroke="#979797"/>
                </g>
                <g id="Rectangle-5" fill="#D8D8D8" transform="rotate(45 420.533 310.283)">
                  <path fill="#D8D8D8" d="M394.494075,284.244075 L383.494072,347.321946 L446.571942,336.321942 L457.571946,273.244072 L394.494075,284.244075 Z" stroke="#979797"/>
                </g>
                <g id="Rectangle-5" fill="#D8D8D8" transform="rotate(45 525.533 383.941)">
                  <path fill="#D8D8D8" d="M499.494075,357.902083 L488.494072,420.979954 L551.571942,409.979951 L562.571946,346.90208 L499.494075,357.902083 Z" stroke="#979797"/>
                </g>
              </g>
              <g id="10m" transform="translate(157.5 220.5)">
                <g id="Rectangle-5" fill="#D8D8D8" transform="rotate(45 53.033 53.033)">
                  <path fill="#D8D8D8" d="M26.9940747,26.9940747 L15.9940717,90.0719455 L79.0719424,79.0719424 L90.0719455,15.9940717 L26.9940747,26.9940747 Z" stroke="#979797"/>
                </g>
                <g id="Rectangle-5" fill="#D8D8D8" transform="rotate(45 263.033 200.033)">
                  <path fill="#D8D8D8" d="M236.994075,173.994075 L225.994072,237.071946 L289.071942,226.071942 L300.071946,162.994072 L236.994075,173.994075 Z" stroke="#979797"/>
                </g>
                <g id="Rectangle-5" fill="#D8D8D8" transform="rotate(45 158.033 126.533)">
                  <path fill="#D8D8D8" d="M131.994075,100.494075 L120.994072,163.571946 L184.071942,152.571942 L195.071946,89.4940717 L131.994075,100.494075 Z" stroke="#979797"/>
                </g>
                <g id="Rectangle-5" fill="#D8D8D8" transform="rotate(45 368.033 273.533)">
                  <path fill="#D8D8D8" d="M341.994075,247.494075 L330.994072,310.571946 L394.071942,299.571942 L405.071946,236.494072 L341.994075,247.494075 Z" stroke="#979797"/>
                </g>
                <g id="Rectangle-5" fill="#D8D8D8" transform="rotate(45 473.033 347.191)">
                  <path fill="#D8D8D8" d="M446.994075,321.152083 L435.994072,384.229954 L499.071942,373.229951 L510.071946,310.15208 L446.994075,321.152083 Z" stroke="#979797"/>
                </g>
                <g id="Rectangle-5" fill="#D8D8D8" transform="rotate(45 105.533 89.783)">
                  <path fill="#D8D8D8" d="M79.4940747,63.7440747 L68.4940717,126.821946 L131.571942,115.821942 L142.571946,52.7440717 L79.4940747,63.7440747 Z" stroke="#979797"/>
                </g>
                <g id="Rectangle-5" fill="#D8D8D8" transform="rotate(45 315.533 236.783)">
                  <path fill="#D8D8D8" d="M289.494075,210.744075 L278.494072,273.821946 L341.571942,262.821942 L352.571946,199.744072 L289.494075,210.744075 Z" stroke="#979797"/>
                </g>
                <g id="Rectangle-5" fill="#D8D8D8" transform="rotate(45 210.533 163.283)">
                  <path fill="#D8D8D8" d="M184.494075,137.244075 L173.494072,200.321946 L236.571942,189.321942 L247.571946,126.244072 L184.494075,137.244075 Z" stroke="#979797"/>
                </g>
                <g id="Rectangle-5" fill="#D8D8D8" transform="rotate(45 420.533 310.283)">
                  <path fill="#D8D8D8" d="M394.494075,284.244075 L383.494072,347.321946 L446.571942,336.321942 L457.571946,273.244072 L394.494075,284.244075 Z" stroke="#979797"/>
                </g>
                <g id="Rectangle-5" fill="#D8D8D8" transform="rotate(45 525.533 383.941)">
                  <path fill="#D8D8D8" d="M499.494075,357.902083 L488.494072,420.979954 L551.571942,409.979951 L562.571946,346.90208 L499.494075,357.902083 Z" stroke="#979797"/>
                </g>
              </g>
              <g id="10m" transform="translate(209.25 183.75)">
                <g id="Rectangle-5" fill="#D8D8D8" transform="rotate(45 53.033 53.033)">
                  <path fill="#D8D8D8" d="M26.9940747,26.9940747 L15.9940717,90.0719455 L79.0719424,79.0719424 L90.0719455,15.9940717 L26.9940747,26.9940747 Z" stroke="#979797"/>
                </g>
                <g id="Rectangle-5" fill="#D8D8D8" transform="rotate(45 263.033 200.033)">
                  <path fill="#D8D8D8" d="M236.994075,173.994075 L225.994072,237.071946 L289.071942,226.071942 L300.071946,162.994072 L236.994075,173.994075 Z" stroke="#979797"/>
                </g>
                <g id="Rectangle-5" fill="#D8D8D8" transform="rotate(45 158.033 126.533)">
                  <path fill="#D8D8D8" d="M131.994075,100.494075 L120.994072,163.571946 L184.071942,152.571942 L195.071946,89.4940717 L131.994075,100.494075 Z" stroke="#979797"/>
                </g>
                <g id="Rectangle-5" fill="#D8D8D8" transform="rotate(45 368.033 273.533)">
                  <path fill="#D8D8D8" d="M341.994075,247.494075 L330.994072,310.571946 L394.071942,299.571942 L405.071946,236.494072 L341.994075,247.494075 Z" stroke="#979797"/>
                </g>
                <g id="Rectangle-5" fill="#D8D8D8" transform="rotate(45 473.033 347.191)">
                  <path fill="#D8D8D8" d="M446.994075,321.152083 L435.994072,384.229954 L499.071942,373.229951 L510.071946,310.15208 L446.994075,321.152083 Z" stroke="#979797"/>
                </g>
                <g id="Rectangle-5" fill="#D8D8D8" transform="rotate(45 105.533 89.783)">
                  <path fill="#D8D8D8" d="M79.4940747,63.7440747 L68.4940717,126.821946 L131.571942,115.821942 L142.571946,52.7440717 L79.4940747,63.7440747 Z" stroke="#979797"/>
                </g>
                <g id="Rectangle-5" fill="#D8D8D8" transform="rotate(45 315.533 236.783)">
                  <path fill="#D8D8D8" d="M289.494075,210.744075 L278.494072,273.821946 L341.571942,262.821942 L352.571946,199.744072 L289.494075,210.744075 Z" stroke="#979797"/>
                </g>
                <g id="Rectangle-5" fill="#D8D8D8" transform="rotate(45 210.533 163.283)">
                  <path fill="#D8D8D8" d="M184.494075,137.244075 L173.494072,200.321946 L236.571942,189.321942 L247.571946,126.244072 L184.494075,137.244075 Z" stroke="#979797"/>
                </g>
                <g id="Rectangle-5" fill="#D8D8D8" transform="rotate(45 420.533 310.283)">
                  <path fill="#D8D8D8" d="M394.494075,284.244075 L383.494072,347.321946 L446.571942,336.321942 L457.571946,273.244072 L394.494075,284.244075 Z" stroke="#979797"/>
                </g>
                <g id="Rectangle-5" fill="#D8D8D8" transform="rotate(45 525.533 383.941)">
                  <path fill="#D8D8D8" d="M499.494075,357.902083 L488.494072,420.979954 L551.571942,409.979951 L562.571946,346.90208 L499.494075,357.902083 Z" stroke="#979797"/>
                </g>
              </g>
              <g id="10m" transform="translate(261.75 147)">
                <g id="Rectangle-5" fill="#D8D8D8" transform="rotate(45 53.033 53.033)">
                  <path fill="#D8D8D8" d="M26.9940747,26.9940747 L15.9940717,90.0719455 L79.0719424,79.0719424 L90.0719455,15.9940717 L26.9940747,26.9940747 Z" stroke="#979797"/>
                </g>
                <g id="Rectangle-5" fill="#D8D8D8" transform="rotate(45 263.033 200.033)">
                  <path fill="#D8D8D8" d="M236.994075,173.994075 L225.994072,237.071946 L289.071942,226.071942 L300.071946,162.994072 L236.994075,173.994075 Z" stroke="#979797"/>
                </g>
                <g id="Rectangle-5" fill="#D8D8D8" transform="rotate(45 158.033 126.533)">
                  <path fill="#D8D8D8" d="M131.994075,100.494075 L120.994072,163.571946 L184.071942,152.571942 L195.071946,89.4940717 L131.994075,100.494075 Z" stroke="#979797"/>
                </g>
                <g id="Rectangle-5" fill="#D8D8D8" transform="rotate(45 368.033 273.533)">
                  <path fill="#D8D8D8" d="M341.994075,247.494075 L330.994072,310.571946 L394.071942,299.571942 L405.071946,236.494072 L341.994075,247.494075 Z" stroke="#979797"/>
                </g>
                <g id="Rectangle-5" fill="#D8D8D8" transform="rotate(45 473.033 347.191)">
                  <path fill="#D8D8D8" d="M446.994075,321.152083 L435.994072,384.229954 L499.071942,373.229951 L510.071946,310.15208 L446.994075,321.152083 Z" stroke="#979797"/>
                </g>
                <g id="Rectangle-5" fill="#D8D8D8" transform="rotate(45 105.533 89.783)">
                  <path fill="#D8D8D8" d="M79.4940747,63.7440747 L68.4940717,126.821946 L131.571942,115.821942 L142.571946,52.7440717 L79.4940747,63.7440747 Z" stroke="#979797"/>
                </g>
                <g id="Rectangle-5" fill="#D8D8D8" transform="rotate(45 315.533 236.783)">
                  <path fill="#D8D8D8" d="M289.494075,210.744075 L278.494072,273.821946 L341.571942,262.821942 L352.571946,199.744072 L289.494075,210.744075 Z" stroke="#979797"/>
                </g>
                <g id="Rectangle-5" fill="#D8D8D8" transform="rotate(45 210.533 163.283)">
                  <path fill="#D8D8D8" d="M184.494075,137.244075 L173.494072,200.321946 L236.571942,189.321942 L247.571946,126.244072 L184.494075,137.244075 Z" stroke="#979797"/>
                </g>
                <g id="Rectangle-5" fill="#D8D8D8" transform="rotate(45 420.533 310.283)">
                  <path fill="#D8D8D8" d="M394.494075,284.244075 L383.494072,347.321946 L446.571942,336.321942 L457.571946,273.244072 L394.494075,284.244075 Z" stroke="#979797"/>
                </g>
                <g id="Rectangle-5" fill="#D8D8D8" transform="rotate(45 525.533 383.941)">
                  <path fill="#D8D8D8" d="M499.494075,357.902083 L488.494072,420.979954 L551.571942,409.979951 L562.571946,346.90208 L499.494075,357.902083 Z" stroke="#979797"/>
                </g>
              </g>
              <g id="10m" transform="translate(314.25 110.25)">
                <g id="Rectangle-5" fill="#D8D8D8" transform="rotate(45 53.033 53.033)">
                  <path fill="#D8D8D8" d="M26.9940747,26.9940747 L15.9940717,90.0719455 L79.0719424,79.0719424 L90.0719455,15.9940717 L26.9940747,26.9940747 Z" stroke="#979797"/>
                </g>
                <g id="Rectangle-5" fill="#D8D8D8" transform="rotate(45 263.033 200.033)">
                  <path fill="#D8D8D8" d="M236.994075,173.994075 L225.994072,237.071946 L289.071942,226.071942 L300.071946,162.994072 L236.994075,173.994075 Z" stroke="#979797"/>
                </g>
                <g id="Rectangle-5" fill="#D8D8D8" transform="rotate(45 158.033 126.533)">
                  <path fill="#D8D8D8" d="M131.994075,100.494075 L120.994072,163.571946 L184.071942,152.571942 L195.071946,89.4940717 L131.994075,100.494075 Z" stroke="#979797"/>
                </g>
                <g id="Rectangle-5" fill="#D8D8D8" transform="rotate(45 368.033 273.533)">
                  <path fill="#D8D8D8" d="M341.994075,247.494075 L330.994072,310.571946 L394.071942,299.571942 L405.071946,236.494072 L341.994075,247.494075 Z" stroke="#979797"/>
                </g>
                <g id="Rectangle-5" fill="#D8D8D8" transform="rotate(45 473.033 347.191)">
                  <path fill="#D8D8D8" d="M446.994075,321.152083 L435.994072,384.229954 L499.071942,373.229951 L510.071946,310.15208 L446.994075,321.152083 Z" stroke="#979797"/>
                </g>
                <g id="Rectangle-5" fill="#D8D8D8" transform="rotate(45 105.533 89.783)">
                  <path fill="#D8D8D8" d="M79.4940747,63.7440747 L68.4940717,126.821946 L131.571942,115.821942 L142.571946,52.7440717 L79.4940747,63.7440747 Z" stroke="#979797"/>
                </g>
                <g id="Rectangle-5" fill="#D8D8D8" transform="rotate(45 315.533 236.783)">
                  <path fill="#D8D8D8" d="M289.494075,210.744075 L278.494072,273.821946 L341.571942,262.821942 L352.571946,199.744072 L289.494075,210.744075 Z" stroke="#979797"/>
                </g>
                <g id="Rectangle-5" fill="#D8D8D8" transform="rotate(45 210.533 163.283)">
                  <path fill="#D8D8D8" d="M184.494075,137.244075 L173.494072,200.321946 L236.571942,189.321942 L247.571946,126.244072 L184.494075,137.244075 Z" stroke="#979797"/>
                </g>
                <g id="Rectangle-5" fill="#D8D8D8" transform="rotate(45 420.533 310.283)">
                  <path fill="#D8D8D8" d="M394.494075,284.244075 L383.494072,347.321946 L446.571942,336.321942 L457.571946,273.244072 L394.494075,284.244075 Z" stroke="#979797"/>
                </g>
                <g id="Rectangle-5" fill="#D8D8D8" transform="rotate(45 525.533 383.941)">
                  <path fill="#D8D8D8" d="M499.494075,357.902083 L488.494072,420.979954 L551.571942,409.979951 L562.571946,346.90208 L499.494075,357.902083 Z" stroke="#979797"/>
                </g>
              </g>
              <g id="10m" transform="translate(366.75 73.5)">
                <g id="Rectangle-5" fill="#D8D8D8" transform="rotate(45 53.033 53.033)">
                  <path fill="#D8D8D8" d="M26.9940747,26.9940747 L15.9940717,90.0719455 L79.0719424,79.0719424 L90.0719455,15.9940717 L26.9940747,26.9940747 Z" stroke="#979797"/>
                </g>
                <g id="Rectangle-5" fill="#D8D8D8" transform="rotate(45 263.033 200.033)">
                  <path fill="#D8D8D8" d="M236.994075,173.994075 L225.994072,237.071946 L289.071942,226.071942 L300.071946,162.994072 L236.994075,173.994075 Z" stroke="#979797"/>
                </g>
                <g id="Rectangle-5" fill="#D8D8D8" transform="rotate(45 158.033 126.533)">
                  <path fill="#D8D8D8" d="M131.994075,100.494075 L120.994072,163.571946 L184.071942,152.571942 L195.071946,89.4940717 L131.994075,100.494075 Z" stroke="#979797"/>
                </g>
                <g id="Rectangle-5" fill="#D8D8D8" transform="rotate(45 368.033 273.533)">
                  <path fill="#D8D8D8" d="M341.994075,247.494075 L330.994072,310.571946 L394.071942,299.571942 L405.071946,236.494072 L341.994075,247.494075 Z" stroke="#979797"/>
                </g>
                <g id="Rectangle-5" fill="#D8D8D8" transform="rotate(45 473.033 347.191)">
                  <path fill="#D8D8D8" d="M446.994075,321.152083 L435.994072,384.229954 L499.071942,373.229951 L510.071946,310.15208 L446.994075,321.152083 Z" stroke="#979797"/>
                </g>
                <g id="Rectangle-5" fill="#D8D8D8" transform="rotate(45 105.533 89.783)">
                  <path fill="#D8D8D8" d="M79.4940747,63.7440747 L68.4940717,126.821946 L131.571942,115.821942 L142.571946,52.7440717 L79.4940747,63.7440747 Z" stroke="#979797"/>
                </g>
                <g id="Rectangle-5" fill="#D8D8D8" transform="rotate(45 315.533 236.783)">
                  <path fill="#D8D8D8" d="M289.494075,210.744075 L278.494072,273.821946 L341.571942,262.821942 L352.571946,199.744072 L289.494075,210.744075 Z" stroke="#979797"/>
                </g>
                <g id="Rectangle-5" fill="#D8D8D8" transform="rotate(45 210.533 163.283)">
                  <path fill="#D8D8D8" d="M184.494075,137.244075 L173.494072,200.321946 L236.571942,189.321942 L247.571946,126.244072 L184.494075,137.244075 Z" stroke="#979797"/>
                </g>
                <g id="Rectangle-5" fill="#D8D8D8" transform="rotate(45 420.533 310.283)">
                  <path fill="#D8D8D8" d="M394.494075,284.244075 L383.494072,347.321946 L446.571942,336.321942 L457.571946,273.244072 L394.494075,284.244075 Z" stroke="#979797"/>
                </g>
                <g id="Rectangle-5" fill="#D8D8D8" transform="rotate(45 525.533 383.941)">
                  <path fill="#D8D8D8" d="M499.494075,357.902083 L488.494072,420.979954 L551.571942,409.979951 L562.571946,346.90208 L499.494075,357.902083 Z" stroke="#979797"/>
                </g>
              </g>
              <g id="10m" transform="translate(418.5 36.75)">
                <g id="Rectangle-5" fill="#D8D8D8" transform="rotate(45 53.033 53.033)">
                  <path fill="#D8D8D8" d="M26.9940747,26.9940747 L15.9940717,90.0719455 L79.0719424,79.0719424 L90.0719455,15.9940717 L26.9940747,26.9940747 Z" stroke="#979797"/>
                </g>
                <g id="Rectangle-5" fill="#D8D8D8" transform="rotate(45 263.033 200.033)">
                  <path fill="#D8D8D8" d="M236.994075,173.994075 L225.994072,237.071946 L289.071942,226.071942 L300.071946,162.994072 L236.994075,173.994075 Z" stroke="#979797"/>
                </g>
                <g id="Rectangle-5" fill="#D8D8D8" transform="rotate(45 158.033 126.533)">
                  <path fill="#D8D8D8" d="M131.994075,100.494075 L120.994072,163.571946 L184.071942,152.571942 L195.071946,89.4940717 L131.994075,100.494075 Z" stroke="#979797"/>
                </g>
                <g id="Rectangle-5" fill="#D8D8D8" transform="rotate(45 368.033 273.533)">
                  <path fill="#D8D8D8" d="M341.994075,247.494075 L330.994072,310.571946 L394.071942,299.571942 L405.071946,236.494072 L341.994075,247.494075 Z" stroke="#979797"/>
                </g>
                <g id="Rectangle-5" fill="#D8D8D8" transform="rotate(45 473.033 347.191)">
                  <path fill="#D8D8D8" d="M446.994075,321.152083 L435.994072,384.229954 L499.071942,373.229951 L510.071946,310.15208 L446.994075,321.152083 Z" stroke="#979797"/>
                </g>
                <g id="Rectangle-5" fill="#D8D8D8" transform="rotate(45 105.533 89.783)">
                  <path fill="#D8D8D8" d="M79.4940747,63.7440747 L68.4940717,126.821946 L131.571942,115.821942 L142.571946,52.7440717 L79.4940747,63.7440747 Z" stroke="#979797"/>
                </g>
                <g id="Rectangle-5" fill="#D8D8D8" transform="rotate(45 315.533 236.783)">
                  <path fill="#D8D8D8" d="M289.494075,210.744075 L278.494072,273.821946 L341.571942,262.821942 L352.571946,199.744072 L289.494075,210.744075 Z" stroke="#979797"/>
                </g>
                <g id="Rectangle-5" fill="#D8D8D8" transform="rotate(45 210.533 163.283)">
                  <path fill="#D8D8D8" d="M184.494075,137.244075 L173.494072,200.321946 L236.571942,189.321942 L247.571946,126.244072 L184.494075,137.244075 Z" stroke="#979797"/>
                </g>
                <g id="Rectangle-5" fill="#D8D8D8" transform="rotate(45 420.533 310.283)">
                  <path fill="#D8D8D8" d="M394.494075,284.244075 L383.494072,347.321946 L446.571942,336.321942 L457.571946,273.244072 L394.494075,284.244075 Z" stroke="#979797"/>
                </g>
                <g id="Rectangle-5" fill="#D8D8D8" transform="rotate(45 525.533 383.941)">
                  <path fill="#D8D8D8" d="M499.494075,357.902083 L488.494072,420.979954 L551.571942,409.979951 L562.571946,346.90208 L499.494075,357.902083 Z" stroke="#979797"/>
                </g>
              </g>
              <g id="10m" transform="translate(471)">
                <g id="Rectangle-5" fill="#D8D8D8" transform="rotate(45 53.033 53.033)">
                  <path fill="#D8D8D8" d="M26.9940747,26.9940747 L15.9940717,90.0719455 L79.0719424,79.0719424 L90.0719455,15.9940717 L26.9940747,26.9940747 Z" stroke="#979797"/>
                </g>
                <g id="Rectangle-5" fill="#D8D8D8" transform="rotate(45 263.033 200.033)">
                  <path fill="#D8D8D8" d="M236.994075,173.994075 L225.994072,237.071946 L289.071942,226.071942 L300.071946,162.994072 L236.994075,173.994075 Z" stroke="#979797"/>
                </g>
                <g id="Rectangle-5" fill="#D8D8D8" transform="rotate(45 158.033 126.533)">
                  <path fill="#D8D8D8" d="M131.994075,100.494075 L120.994072,163.571946 L184.071942,152.571942 L195.071946,89.4940717 L131.994075,100.494075 Z" stroke="#979797"/>
                </g>
                <g id="Rectangle-5" fill="#D8D8D8" transform="rotate(45 368.033 273.533)">
                  <path fill="#D8D8D8" d="M341.994075,247.494075 L330.994072,310.571946 L394.071942,299.571942 L405.071946,236.494072 L341.994075,247.494075 Z" stroke="#979797"/>
                </g>
                <g id="Rectangle-5" fill="#D8D8D8" transform="rotate(45 473.033 347.191)">
                  <path fill="#D8D8D8" d="M446.994075,321.152083 L435.994072,384.229954 L499.071942,373.229951 L510.071946,310.15208 L446.994075,321.152083 Z" stroke="#979797"/>
                </g>
                <g id="Rectangle-5" fill="#D8D8D8" transform="rotate(45 105.533 89.783)">
                  <path fill="#D8D8D8" d="M79.4940747,63.7440747 L68.4940717,126.821946 L131.571942,115.821942 L142.571946,52.7440717 L79.4940747,63.7440747 Z" stroke="#979797"/>
                </g>
                <g id="Rectangle-5" fill="#D8D8D8" transform="rotate(45 315.533 236.783)">
                  <path fill="#D8D8D8" d="M289.494075,210.744075 L278.494072,273.821946 L341.571942,262.821942 L352.571946,199.744072 L289.494075,210.744075 Z" stroke="#979797"/>
                </g>
                <g id="Rectangle-5" fill="#D8D8D8" transform="rotate(45 210.533 163.283)">
                  <path fill="#D8D8D8" d="M184.494075,137.244075 L173.494072,200.321946 L236.571942,189.321942 L247.571946,126.244072 L184.494075,137.244075 Z" stroke="#979797"/>
                </g>
                <g id="Rectangle-5" fill="#D8D8D8" transform="rotate(45 420.533 310.283)">
                  <path fill="#D8D8D8" d="M394.494075,284.244075 L383.494072,347.321946 L446.571942,336.321942 L457.571946,273.244072 L394.494075,284.244075 Z" stroke="#979797"/>
                </g>
                <g id="Rectangle-5" fill="#D8D8D8" transform="rotate(45 525.533 383.941)">
                  <path fill="#D8D8D8" d="M499.494075,357.902083 L488.494072,420.979954 L551.571942,409.979951 L562.571946,346.90208 L499.494075,357.902083 Z" stroke="#979797"/>
                </g>
              </g>
            </g>
          </g>
        </svg>
        <Desk ratio={ this.state.ratio } />
        <Pretreat ratio={ this.state.ratio } />
        <Press ratio={ this.state.ratio } />
        <Gtx1 ratio={ this.state.ratio } />
        <Gtx2 ratio={ this.state.ratio } />
        <Gtx3 ratio={ this.state.ratio } />
        <Gtx4 ratio={ this.state.ratio } />
        <Senddesk ratio={ this.state.ratio } />
        <Dryer ratio={ this.state.ratio } />
      </div>
    )
  }
}

class Gtx1 extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      originalWidth: 264,
      originalHeight: 188,
      x: 0,
      y: -500,
      opacity: 0,
      ratio: parseFloat(props.ratio)
    }
    this.state = {
      ...this.state,
      width: this.state.originalWidth / this.state.ratio,
      height: this.state.originalHeight / this.state.ratio
    }
  }
  getKeyFrames() {
      return [
          { transform: 'translateY(-500px)', opacity: 0, offset: 0 },
          { opacity: 1, offset: 1 },
          { transform: 'translateY(0)', opacity: 1, offset: 1 }
      ]
  }
  getTiming( duration ) {
      return {
          duration,
          easing: 'ease-in',
          delay: 0,
          iterations: 1,
          fill: 'forwards'
      }
  }
  render() {
    return (
      <Animated.img keyframes={this.getKeyFrames()} timing={this.getTiming(750)} style={{ position: 'absolute', top: 278 / this.state.ratio, left: 471 / this.state.ratio, opacity: this.state.opacity, transform: [{ translateY: this.state.y }], width: this.state.width, height: this.state.height }} src={require("./devices/gtx.png")} />
    )
  }
}

class Gtx2 extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      originalWidth: 264,
      originalHeight: 188,
      x: 0,
      y: -500,
      opacity: 0,
      ratio: parseFloat(props.ratio)
    }
    this.state = {
      ...this.state,
      width: this.state.originalWidth / this.state.ratio,
      height: this.state.originalHeight / this.state.ratio
    }
  }
  getKeyFrames() {
      return [
          { transform: 'translateY(-500px)', opacity: 0, offset: 0 },
          { opacity: 1, offset: 1 },
          { transform: 'translateY(0)', opacity: 1, offset: 1 }
      ]
  }
  getTiming( duration ) {
      return {
          duration,
          easing: 'ease-in',
          delay: 0,
          iterations: 1,
          fill: 'forwards'
      }
  }
  render() {
    return (
      <Animated.img keyframes={this.getKeyFrames()} timing={this.getTiming(750)} style={{ position: 'absolute', top: 352 / this.state.ratio, left: 577 / this.state.ratio, opacity: this.state.opacity, transform: [{ translateY: this.state.y }], width: this.state.width, height: this.state.height }} src={require("./devices/gtx.png")} />
    )
  }
}

class Gtx3 extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      originalWidth: 264,
      originalHeight: 188,
      x: 0,
      y: -500,
      opacity: 0,
      ratio: parseFloat(props.ratio)
    }
    this.state = {
      ...this.state,
      width: this.state.originalWidth / this.state.ratio,
      height: this.state.originalHeight / this.state.ratio
    }
  }
  getKeyFrames() {
      return [
          { transform: 'translateY(-500px)', opacity: 0, offset: 0 },
          { opacity: 1, offset: 1 },
          { transform: 'translateY(0)', opacity: 1, offset: 1 }
      ]
  }
  getTiming( duration ) {
      return {
          duration,
          easing: 'ease-in',
          delay: 0,
          iterations: 1,
          fill: 'forwards'
      }
  }
  render() {
    return (
      <Animated.img keyframes={this.getKeyFrames()} timing={this.getTiming(750)} style={{ position: 'absolute', top: 425 / this.state.ratio, left: 683 / this.state.ratio, opacity: this.state.opacity, transform: [{ translateY: this.state.y }], width: this.state.width, height: this.state.height }} src={require("./devices/gtx.png")} />
    )
  }
}

class Gtx4 extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      originalWidth: 264,
      originalHeight: 188,
      x: 0,
      y: -500,
      opacity: 0,
      ratio: parseFloat(props.ratio)
    }
    this.state = {
      ...this.state,
      width: this.state.originalWidth / this.state.ratio,
      height: this.state.originalHeight / this.state.ratio
    }
  }
  getKeyFrames() {
      return [
          { transform: 'translateY(-500px)', opacity: 0, offset: 0 },
          { opacity: 1, offset: 1 },
          { transform: 'translateY(0)', opacity: 1, offset: 1 }
      ]
  }
  getTiming( duration ) {
      return {
          duration,
          easing: 'ease-in',
          delay: 0,
          iterations: 1,
          fill: 'forwards'
      }
  }
  render() {
    return (
      <Animated.img keyframes={this.getKeyFrames()} timing={this.getTiming(750)} style={{ position: 'absolute', top: 497 / this.state.ratio, left: 789 / this.state.ratio, opacity: this.state.opacity, transform: [{ translateY: this.state.y }], width: this.state.width, height: this.state.height }} src={require("./devices/gtx.png")} />
    )
  }
}

class Senddesk extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      originalWidth: 212,
      originalHeight: 170,
      x: 0,
      y: -500,
      opacity: 0,
      ratio: parseFloat(props.ratio)
    }
    this.state = {
      ...this.state,
      width: this.state.originalWidth / this.state.ratio,
      height: this.state.originalHeight / this.state.ratio
    }
  }
  getKeyFrames() {
      return [
          { transform: 'translateY(-500px)', opacity: 0, offset: 0 },
          { opacity: 1, offset: 1 },
          { transform: 'translateY(0)', opacity: 1, offset: 1 }
      ]
  }
  getTiming( duration ) {
      return {
          duration,
          easing: 'ease-in',
          delay: 0,
          iterations: 1,
          fill: 'forwards'
      }
  }
  render() {
    return (
      <Animated.img keyframes={this.getKeyFrames()} timing={this.getTiming(750)} style={{ position: 'absolute', top: 515 / this.state.ratio, left: 574 / this.state.ratio, opacity: this.state.opacity, transform: [{ translateY: this.state.y }], width: this.state.width, height: this.state.height }} src={require("./devices/senddesk.png")} />
    )
  }
}

class Desk extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      originalWidth: 212,
      originalHeight: 150,
      x: 0,
      y: -500,
      opacity: 0,
      ratio: parseFloat(props.ratio)
    }
    this.state = {
      ...this.state,
      width: this.state.originalWidth / this.state.ratio,
      height: this.state.originalHeight / this.state.ratio
    }
  }
  getKeyFrames() {
      return [
          { transform: 'translateY(-500px)', opacity: 0, offset: 0 },
          { opacity: 1, offset: 1 },
          { transform: 'translateY(0)', opacity: 1, offset: 1 }
      ]
  }
  getTiming( duration ) {
      return {
          duration,
          easing: 'ease-in',
          delay: 0,
          iterations: 1,
          fill: 'forwards'
      }
  }
  render() {
    return (
      <Animated.img keyframes={this.getKeyFrames()} timing={this.getTiming(750)} style={{ position: 'absolute', top: 424 / this.state.ratio, left: 418 / this.state.ratio, opacity: this.state.opacity, transform: [{ translateY: this.state.y }], width: this.state.width, height: this.state.height }} src={require("./devices/desk.png")} />
    )
  }
}

class Press extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      originalWidth: 160,
      originalHeight: 156,
      x: 0,
      y: -500,
      opacity: 0,
      ratio: parseFloat(props.ratio)
    }
    this.state = {
      ...this.state,
      width: this.state.originalWidth / this.state.ratio,
      height: this.state.originalHeight / this.state.ratio
    }
  }
  getKeyFrames() {
      return [
          { transform: 'translateY(-500px)', opacity: 0, offset: 0 },
          { opacity: 1, offset: 1 },
          { transform: 'translateY(0)', opacity: 1, offset: 1 }
      ]
  }
  getTiming( duration ) {
      return {
          duration,
          easing: 'ease-in',
          delay: 0,
          iterations: 1,
          fill: 'forwards'
      }
  }
  render() {
    return (
      <Animated.img keyframes={this.getKeyFrames()} timing={this.getTiming(750)} style={{ position: 'absolute', top: 197 / this.state.ratio, left: 419 / this.state.ratio, opacity: this.state.opacity, transform: [{ translateY: this.state.y }], width: this.state.width, height: this.state.height }} src={require("./devices/press.png")} />
    )
  }
}

class Pretreat extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      originalWidth: 160,
      originalHeight: 149,
      x: 0,
      y: -500,
      opacity: 0,
      ratio: parseFloat(props.ratio)
    }
    this.state = {
      ...this.state,
      width: this.state.originalWidth / this.state.ratio,
      height: this.state.originalHeight / this.state.ratio
    }
  }
  getKeyFrames() {
      return [
          { transform: 'translateY(-500px)', opacity: 0, offset: 0 },
          { opacity: 1, offset: 1 },
          { transform: 'translateY(0)', opacity: 1, offset: 1 }
      ]
  }
  getTiming( duration ) {
      return {
          duration,
          easing: 'ease-in',
          delay: 0,
          iterations: 1,
          fill: 'forwards'
      }
  }
  render() {
    return (
      <Animated.img keyframes={this.getKeyFrames()} timing={this.getTiming(750)} style={{ position: 'absolute', top: 168 / this.state.ratio, left: 470 / this.state.ratio, opacity: this.state.opacity, transform: [{ translateY: this.state.y }], width: this.state.width, height: this.state.height }} src={require("./devices/pretreat.png")} />
    )
  }
}

class Dryer extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      originalWidth: 420,
      originalHeight: 316,
      x: 0,
      y: -500,
      opacity: 0,
      ratio: parseFloat(props.ratio)
    }
    this.state = {
      ...this.state,
      width: this.state.originalWidth / this.state.ratio,
      height: this.state.originalHeight / this.state.ratio
    }
  }
  getKeyFrames() {
      return [
          { transform: 'translateY(-500px)', opacity: 0, offset: 0 },
          { opacity: 1, offset: 1 },
          { transform: 'translateY(0)', opacity: 1, offset: 1 }
      ]
  }
  getTiming( duration ) {
      return {
          duration,
          easing: 'ease-in',
          delay: 0,
          iterations: 1,
          fill: 'forwards'
      }
  }
  render() {
    return (
      <Animated.img keyframes={this.getKeyFrames()} timing={this.getTiming(750)} style={{ position: 'absolute', top: 300 / this.state.ratio, left: 103 / this.state.ratio, opacity: this.state.opacity, transform: [{ translateY: this.state.y }], width: this.state.width, height: this.state.height }} src={require("./devices/dryer.png")} />
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/room/rooms/L.js